import * as apis from "../../apis";
import * as errors from "../../errors";
import * as successes from "../../successes";
import {getAxiosTokenConfig} from "../../helpers";
import axios from "../../axios/axios";


import {notifyError, notifySuccess} from "../../toast-notifications";
import { getZoneItems } from "./zones";
import { CLOSE_ARTEFACT_MODAL } from "./ui";

// GET ARTEFACTS
export const GET_ARTEFACTS_REQUEST = "GET_ARTEFACTS_REQUEST";
export const GET_ARTEFACTS_SUCCESS = "GET_ARTEFACTS_SUCCESS";
export const GET_ARTEFACTS_ERROR = "GET_ARTEFACTS_ERROR";

export const getArtefactsRequest = () => {
    return {
        type: GET_ARTEFACTS_REQUEST,
        loading: true
    };
};
export const getArtefactsSuccess = (artefacts) => {
    return {
        type: GET_ARTEFACTS_SUCCESS,
        loading: false,
        error: null,
        artefacts
    };
};
export const getArtefactsError = (error) => {
    return {
        type: GET_ARTEFACTS_ERROR,
        loading: false,
        error
    };
};

export const getArtefacts = () => {
    return dispatch => {
        dispatch(getArtefactsRequest());
        axios.get(apis.ARTEFACTS_API , getAxiosTokenConfig())
            .then(response => {
                dispatch(getArtefactsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getArtefactsError(errors.GET_ARTEFACTS_ERROR));
                notifyError(errors.GET_ARTEFACTS_ERROR);
            });
    };
};

// ADD ARTEFACT
export const ADD_ARTEFACT_REQUEST = "ADD_ARTEFACT_REQUEST";
export const ADD_ARTEFACT_SUCCESS = "ADD_ARTEFACT_SUCCESS";
export const ADD_ARTEFACT_ERROR = "ADD_ARTEFACT_ERROR";

export const addArtefactRequest = () => {
    return {
        type: ADD_ARTEFACT_REQUEST,
        loading: true
    };
};
export const addArtefactSuccess = (artefact) => {
    return {
        type: ADD_ARTEFACT_SUCCESS,
        loading: false,
        error: null,
        artefact
    };
};
export const addArtefactError = (error) => {
    return {
        type: ADD_ARTEFACT_ERROR,
        loading: false,
        error
    };
};

export const addArtefact = (artefact) => {
    return dispatch => {
        dispatch(addArtefactRequest());
        axios.post(apis.ARTEFACTS_API , artefact, getAxiosTokenConfig())
            .then(response => {
                dispatch(getZoneItems());
                dispatch(addArtefactSuccess(response.data));
                notifySuccess(successes.ADD_ARTEFACT_SUCCESS);
            })
            .catch(error => {
                dispatch(addArtefactError(errors.ADD_ARTEFACT_ERROR));
                notifyError(errors.ADD_ARTEFACT_ERROR);
            })
            .finally(() => {
                dispatch({type: CLOSE_ARTEFACT_MODAL});
            });
    };
};

// DELETE ARTEFACT
export const DELETE_ARTEFACT_REQUEST = "DELETE_ARTEFACT_REQUEST";
export const DELETE_ARTEFACT_SUCCESS = "DELETE_ARTEFACT_SUCCESS";
export const DELETE_ARTEFACT_ERROR = "DELETE_ARTEFACT_ERROR";

export const deleteArtefactRequest = () => {
    return {
        type: DELETE_ARTEFACT_REQUEST,
        loading: true
    };
};
export const deleteArtefactSuccess = (artefactId) => {
    return {
        type: DELETE_ARTEFACT_SUCCESS,
        loading: false,
        error: null,
        artefactId
    };
};
export const deleteArtefactError = (error) => {
    return {
        type: DELETE_ARTEFACT_ERROR,
        loading: false,
        error
    };
};

export const deleteArtefact = (artefactId) => {
    return dispatch => {
        dispatch(deleteArtefactRequest());
        axios.delete(apis.ARTEFACTS_BY_ID_API(artefactId), getAxiosTokenConfig())
            .then(response => {
                dispatch(getZoneItems());
                dispatch(deleteArtefactSuccess(response.data));
                notifySuccess(successes.DELETE_ARTEFACT_SUCCESS);
            })
            .catch(error => {
                dispatch(deleteArtefactError(errors.DELETE_ARTEFACT_ERROR));
                notifyError(errors.DELETE_ARTEFACT_ERROR);
            })
            .finally(() => {
                dispatch({type: CLOSE_ARTEFACT_MODAL});
            });
    };
};

// UPDATE ARTEFACT
export const UPDATE_ARTEFACT_REQUEST = "UPDATE_ARTEFACT_REQUEST";
export const UPDATE_ARTEFACT_SUCCESS = "UPDATE_ARTEFACT_SUCCESS";
export const UPDATE_ARTEFACT_ERROR = "UPDATE_ARTEFACT_ERROR";

export const updateArtefactRequest = () => {
    return {
        type: UPDATE_ARTEFACT_REQUEST,
        loading: true
    };
};
export const updateArtefactSuccess = (artefact) => {
    return {
        type: UPDATE_ARTEFACT_SUCCESS,
        loading: false,
        error: null,
        artefact
    };
};
export const updateArtefactError = (error) => {
    return {
        type: UPDATE_ARTEFACT_ERROR,
        loading: false,
        error
    };
};

export const updateArtefact = (artefact) => {
    return dispatch => {
        dispatch(updateArtefactRequest());
        axios.patch(apis.ARTEFACTS_BY_ID_API(artefact.id), artefact, getAxiosTokenConfig())
            .then(response => {
                dispatch(getZoneItems());
                dispatch(updateArtefactSuccess(response.data));
                notifySuccess(successes.UPDATE_ARTEFACT_SUCCESS);
            })
            .catch(error => {
                dispatch(updateArtefactError(errors.UPDATE_ARTEFACT_ERROR));
                notifyError(errors.UPDATE_ARTEFACT_ERROR);
            })
            .finally(() => {
                dispatch({type: CLOSE_ARTEFACT_MODAL});
            });
    };
};

// GET ARTEFACTS
export const GET_ARTEFACT_TYPES_REQUEST = "GET_ARTEFACT_TYPES_REQUEST";
export const GET_ARTEFACT_TYPES_SUCCESS = "GET_ARTEFACT_TYPES_SUCCESS";
export const GET_ARTEFACT_TYPES_ERROR = "GET_ARTEFACT_TYPES_ERROR";

export const getArtefactTypesRequest = () => {
    return {
        type: GET_ARTEFACT_TYPES_REQUEST,
        loading: true
    };
};
export const getArtefactTypesSuccess = (types) => {
    return {
        type: GET_ARTEFACT_TYPES_SUCCESS,
        loading: false,
        error: null,
        types
    };
};
export const getArtefactTypesError = (error) => {
    return {
        type: GET_ARTEFACT_TYPES_ERROR,
        loading: false,
        error
    };
};

export const getArtefactTypes = () => {
    return dispatch => {
        dispatch(getArtefactTypesRequest());
        axios.get(apis.ARTEFACT_TYPES_API , getAxiosTokenConfig())
            .then(response => {
                dispatch(getArtefactTypesSuccess(response.data));
            })
            .catch(error => {
                dispatch(getArtefactTypesError(errors.GET_ARTEFACT_TYPES_ERROR));
                notifyError(errors.GET_ARTEFACT_TYPES_ERROR);
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/artefacts.js